import { render, staticRenderFns } from "./add-driver-dialog.vue?vue&type=template&id=1edae83f&scoped=true"
import script from "./add-driver-dialog.vue?vue&type=script&lang=js"
export * from "./add-driver-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edae83f",
  null
  
)

export default component.exports